import {
  createRouter,
  createWebHashHistory,
  createWebHistory,
} from "vue-router";
import { useKeepAliveStore } from "@/store/keepAliveStore.js";
const routes = [
  {
    path: "/",
    name: "root",
    component: () => import("@/layouts/MainLayout/index.jsx"),
    children: [
      {
        path: "",
        name: "home",
        component: () =>
          import(/* webpackChunkName: "home" */ "../views/Home/index.jsx"),
      },
      {
        path: "",
        name: "menu",
        //有菜单 无边距
        component: () =>
          import(
            /* webpackChunkName: "menu" */ "@/layouts/MenuBarLayout/index.jsx"
          ),
        children: [
          {
            path: "",
            name: "content",
            // 有边距
            component: () =>
              import(
                /* webpackChunkName: "content" */ "@/layouts/ContentLayout/index.jsx"
              ),
            children: [
              {
                path: "PolicyDetails",
                name: "PolicyDetails",
                component: () =>
                  import(
                    /* webpackChunkName: "PolicyDetails" */ "../views/PolicyDetails/index.jsx"
                  ),
                children: [
                  {
                    path: "details",
                    name: "details",
                    component: () =>
                      import(
                        /* webpackChunkName: "details" */ "../views/PolicyDetails/details/index.jsx"
                      ),
                  },
                  {
                    path: "compare",
                    name: "Compare",
                    component: () =>
                      import(
                        /* webpackChunkName: "Compare" */ "../views/Compare/index.jsx"
                      ),
                  },
                ],
              },
              {
                path: "search",
                name: "searchome",
                component: () =>
                  import(
                    /* webpackChunkName: "searchResult" */ "../views/SearchResult/index.jsx"
                  ),
                beforeEnter: (to, from) => {
                  const keepAliveStore = useKeepAliveStore();
                  const name = from.name;
                  const include = ["details"];
                  if (!include.includes(name)) {
                    keepAliveStore.rmInclude("search-result");
                  }
                },
              },
              {
                path: "Calculator",
                name: "Calculator",
                component: () => import("../views/Calculator/index.jsx"),
                children: [
                  {
                    path: "transition",
                    name: "transition",
                    component: () =>
                      import(
                        /* webpackChunkName: "transition" */ "../views/Calculator/transition/index.jsx"
                      ),
                  },
                  {
                    path: "result",
                    name: "result",
                    component: () =>
                      import(
                        /* webpackChunkName: "result" */ "../views/Calculator/result/index.jsx"
                      ),
                  },
                ],
              },

              {
                path: "subscribe",
                name: "Subscribe",
                component: () =>
                  import(
                    /* webpackChunkName: "Subscribe" */ "../views/Subscribe/index.jsx"
                  ),
                beforeEnter: (to, from) => {
                  const keepAliveStore = useKeepAliveStore();
                  const name = from.name;
                  const include = ["details"];
                  if (!include.includes(name)) {
                    keepAliveStore.rmInclude("subscribePage");
                  }
                },
              },
              {
                path: "collect",
                name: "Collect",
                component: () =>
                  import(
                    /* webpackChunkName: "Collect" */ "../views/Collect/index.jsx"
                  ),
                beforeEnter: (to, from) => {
                  const keepAliveStore = useKeepAliveStore();
                  const name = from.name;
                  const include = ["details"];
                  if (!include.includes(name)) {
                    keepAliveStore.rmInclude("collectPage");
                  }
                },
              },
              {
                path: "industry",
                name: "Industry",
                component: () =>
                  import(
                    /* webpackChunkName: "Industry" */ "../views/Industry/index.jsx"
                  ),
              },
            ],
          },
          {
            path: "cover",
            name: "cover",
            component: () =>
              import(
                /* webpackChunkName: "cover" */ "../views/Calculator/cover/index.jsx"
              ),
          },
        ],
      },
    ],
  },
  {
    path: "/",
    name: "inner",
    component: () => import("@/layouts/Inner/index.jsx"),
    children: [
      {
        path: "aiTalk",
        name: "AiTalk",
        component: () =>
          import(/* webpackChunkName: "Calc" */ "../views/AiTalk/index.jsx"),
      },
    ],
  },
  {
    path: "/",
    name: "ALlLayout",
    component: () => import("@/layouts/ALlLayout/index.jsx"),
    children: [
      {
        path: "calcEnter",
        name: "calcCover",
        component: () =>
          import(
            /* webpackChunkName: "cover" */ "../views/Calculator/cover/index.jsx"
          ),
      },
      {
        path: "calc",
        name: "Calc",
        component: () =>
          import(/* webpackChunkName: "Calc" */ "../views/Calc/index.jsx"),
      },
      {
        path: "calcResult",
        name: "CalcResult",
        component: () =>
          import(
            /* webpackChunkName: "Calc" */ "../views/CalcResult/index.jsx"
          ),
      },
      {
        path: "calcInfinity",
        name: "CalcInfinity",
        component: () =>
          import(
            /* webpackChunkName: "Calc" */ "../views/CalcInfinity/index.jsx"
          ),
      },
      {
        path: "load",
        name: "Load",
        component: () => import("../views/Load/index.jsx"),
      },
    ],
  },
];

const router = createRouter({
  history:
    process.env.VUE_APP_MODE === "IRS"
      ? createWebHashHistory()
      : createWebHistory(process.env.VUE_APP_PUBLIC_PATH),

  routes,
});

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0); //切换路由之后滚动条始终在最顶部
});
export default router;
